export default "__VITE_ASSET__CoZfsWFk__"